import React from 'react'

const Detail = (props) => {
    return (
        typeof props.value === 'object' && props.value !== null
            ? <div {...props}>
                <div className='pb-1 bold'>{props.title}</div>
                <div>
                    {props.value.map((item, key) => {
                        return <div key={key} dangerouslySetInnerHTML={{ __html: item }} />
                    })}
                </div>
              </div>
            :			<div {...props}>
                <div className='pb-1'>{props.title}</div>
                <div className='bold' dangerouslySetInnerHTML={{ __html: props.value }} />
                </div>
    )
}

export default Detail



// WEBPACK FOOTER //
// ./resources/js/elements/Detail.js